import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { sendToSheetCheck } from '../utils/sendForm';
import { trackGAEvent } from '../utils/GA4';

export default function NavigationListener() {
    const location = useLocation();

    useEffect(() => {
        // console.log("Page changed to:", location.pathname);
        handleNavigation(location.pathname);
    }, [location.pathname]); // runs every time location changes

    function handleNavigation(pathname) {
        // console.log("Custom function triggered on path:", pathname);
        sendToSheetCheck();

        if (pathname.includes('get-started')) trackGAEvent('PF Get Started');
        if (pathname.includes('final')) trackGAEvent('PF Completed');
    }

    return null; // This component doesn't render anything
}
